<template>
  <div>
    <v-snackbar
      v-model="snackbar.ativo"
      :timeout="snackbar.timeout"
      top
      right
      color="success"
    >{{ snackbar.text }}</v-snackbar>
    <v-content>
      <v-layout row wrap>
        <v-flex md4 xs5>
          <v-text-field v-on:keyup.enter="filtrar" label="Número" v-model="filtro.pedido"></v-text-field>
        </v-flex>

        <v-flex md5 xs5>
          <v-text-field v-on:keyup.enter="filtrar" label="CNPJ ou Nome" v-model="filtro.cnpj"></v-text-field>
        </v-flex>

        <v-flex xs3 class="text-xs-center">
          <v-btn style="margin-top: 15px;" color="#005ca3" dark @click="filtrar">Filtrar</v-btn>
        </v-flex>
      </v-layout>
    </v-content>

    <app-card-crud
      title="Liberações de Pagamentos"
      @carregarEstrangeiros="carregarEstrangeiros()"
      :valid="false"
      :formTitle="formTitle"
      btnAddColor="#ff0d7b"
      btnRefreshColor="#607D8B"
      v-model="liberacaoFormDialog"
      :isValid="validarFormulario"
      :loadingSave="loadingSave"
      @close="() => {
            zerarVariaveis();
            costCenterErrorMessages = [];
            close('liberacaoFormDialog', 'formLiberacao');
          }"
      @save="() => {
            save({
              formName: 'formLiberacao',
              loaderName: 'loadingDepartments',
              service: '/validacao',
              newContent: editedItem,
              getService: '/validacao/busca?pedido=&fornecedor=',
              itemName: 'pagamentos',
              closeFunction: () => { 
                zerarVariaveis();
                close('liberacaoFormDialog', 'formLiberacao')
                 }
            });

          }"
      @refresh="initialize"
    >
      <template slot="form">
        <v-form v-model="isValid" ref="formLiberacao">
          <v-switch
            :label="`Status: ${formataStatus(editedItem.status)}`"
            :rules="statusRules"
            validate-on-blur
            v-model="editedItem.status"
          ></v-switch>

          <v-text-field label="Número do Pedido" v-model="editedItem.pedido" :rules="numberRules"></v-text-field>

          <p class="v-label theme--light mb-0 pt-0">Selecione o tipo de fornecedor</p>
          <v-radio-group class="mt-1 local-radio mb-0" row v-model="tipoSelecionado">
            <v-radio
              v-for="n in itensTipoFornecedor"
              :key="n.tipo"
              :label="`${n.tipo}`"
              :disabled="editedIndexCnpj > -1"
              :value="n.tipo"
              class="pt-0 mb-0"
            ></v-radio>
          </v-radio-group>
          <v-layout row wrap>
            <v-flex xs9>
              <v-text-field
                v-if="tipoSelecionado == 'Jurídico'"
                type="text"
                label="CNPJ"
                v-model="cnpjDigitado"
                mask="##.###.###/####-##"
                :rules="cnpjRules"
                :loading="loadingCNPJ"
                @click:append="adicionaCnpj()"
                @input="debounceValidation()"
                class="pt-0 mt-0"
              ></v-text-field>

              <v-autocomplete
                label="Selecione Fornecedor Estrangeiro"
                :items="estrangeiros"
                :loading="loadingEstrangeiros"
                item-text="nome"
                v-model="cnpjItem"
                return-object
                :rules="cnpjRules"
                v-else
              ></v-autocomplete>
            </v-flex>

            <v-flex xs3 class="pt-3">
              <v-btn
                class="ml-0 mt-2"
                :loading="loadingCNPJ"
                :disabled="!cnpjValidado"
                @click="adicionaCnpj()"
                small
                flat
                color="blue"
              >
                <v-icon>add</v-icon>
                {{ txtBtn }}
              </v-btn>
            </v-flex>
          </v-layout>

          <div v-if="tipoSelecionado == 'Jurídico'">
            <p v-if="cnpjValidado">Fornecedor Localizado: {{ cnpjLocalizado.nome }}</p>
            <p v-else>{{ msgErroCnpj }}</p>
          </div>
          <!-- Listagem dos fornecedores -->
          <v-list v-if="editedItem.fornecedores.length > 0 && !loadingDepartments">
            <v-list-tile-sub-title>Fornecedores Adicionados</v-list-tile-sub-title>
            <v-list-tile
              v-for="(item, index) in editedItem.fornecedores"
              :key="item.index"
              style="border-bottom: 1px solid #e8e8e8;"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple @click="editarCnpj(item, index)">
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
              </v-list-tile-action>
              <v-list-tile-action>
                <v-btn icon ripple @click="deletarCnpj(item, index)">
                  <v-icon color="grey lighten-1">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <v-progress-linear v-if="loadingDepartments" indeterminate></v-progress-linear>

          <!-- Listagem dos Logs -->
          <logs-pedidos
            v-if="editedItem.logs != null"
            :logs="editedItem.logs.map(log => log.descricao)"
          ></logs-pedidos>
        </v-form>
      </template>
      <template slot="table">
        <v-data-table
          :items="pagamentos.content"
          :headers="headerPagamentos"
          hide-actions
          class="headerColor"
          :loading="loadingDepartments"
        >
          <v-progress-linear slot="progress" color="blue" height="5" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
              <td>{{ props.item.pedido }}</td>
              <td>{{ formataStatus(props.item.status) }}</td>
              <td class="justify-center layout px-0">
                <v-tooltip bottom class="paddingTooltip">
                  <v-icon
                    slot="activator"
                    @click="() => {
                            editItem(props.item, 'pagamentos', 'liberacaoFormDialog')
                          }"
                  >edit</v-icon>
                  <span>Editar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>

          <template slot="expand" slot-scope="props">
            <div
              flat
              v-for="cnpj in formatarListaCnpj(props.item.fornecedores)"
              :key="cnpj"
              class="listaCnpj"
            >{{ cnpj }}</div>
          </template>

          <template slot="no-data" v-if="loadingDepartments">
            <v-layout row wrap justify-center>
              <v-progress-circular indeterminate color="blue"></v-progress-circular>
            </v-layout>
          </template>
          <template slot="no-data" v-else>
            <div class="text-xs-center">Não há pagamentos cadastrados.</div>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2" v-if="quantidadeDeItens > 0">
          <v-pagination v-model="pagination.page" :length="pagamentos.totalPages"></v-pagination>
        </div>
      </template>
    </app-card-crud>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppCardCrud from "@/components/shared/AppCardCrud";
import crudMixin from "@/mixins/crudMixin";
import LogsPedidos from "@/components/solicitacao/LogsPedidos.vue";
import get from "lodash.get";
import axios from "axios";
import debounce from "lodash.debounce";

export default {
  components: {
    AppCardCrud,
    LogsPedidos
  },
  mixins: [crudMixin],
  data() {
    return {
      loadingCNPJ: false,
      loadingEstrangeiros: false,
      cnpjValidado: false,
      cnpjLocalizado: {},
      msgErroCnpj: "Digite um fornecedor válido acima.",
      txtBtn: "Adicionar",
      cnpjItem: {},
      cnpjDigitado: "",
      itensTipoFornecedor: [{ tipo: "Jurídico" }, { tipo: "Estrangeiro" }],
      tipoSelecionado: "Jurídico",
      editedIndexCnpj: -1,
      pagination: {
        page: 1
      },
      filtro: {
        pedido: "",
        cnpj: ""
      },
      liberacaoFormDialog: false,
      editedIndex: -1,
      editedItem: {
        status: true,
        pedido: null,
        fornecedores: []
      },
      defaultItem: {
        status: true,
        pedido: null,
        fornecedores: []
      },
      isValid: false,
      costCenterErrorMessages: [],
      loadingCostCenterValidation: false,
      nameRules: [name => !!name || "O preenchimento do nome é obrigatório."],
      numberRules: [
        number => !!number || "Este campo é obrigatório.",
        number =>
          (!isNaN(parseFloat(number)) && isFinite(number)) ||
          "Digite apenas números."
      ],
      statusRules: [st => (this.isValid = true)],
      cnpjRules: [
        number => !!number || true,
        number => {
          if (!!number) return true;

          (!isNaN(parseFloat(number)) && isFinite(number)) ||
            "Digite apenas números.";
        }
      ],
      headerPagamentos: [
        { text: "Numero do Pedido", value: "documento", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Ações", sortable: false, align: "center", width: "20%" }
      ],
      snackbar: {
        ativo: false,
        timeout: 6000,
        text: "Salvo com successo!"
      },
      servico: "",
      estrangeiros: [],
      loadingSave: false
    };
  },
  watch: {
    "pagination.page"(val) {
      if (this.servico.indexOf("busca?") != -1)
        this.servico = `/validacao/busca?pedido=${pedido}&fornecedor=${cnpj}&`;
      this.$store.dispatch("get", {
        loaderName: "loadingDepartments",
        service: `${this.servico}pagina=${this.pagination.page - 1}`,
        itemName: "pagamentos"
      });
    },
    tipoSelecionado(newVal) {
      if (newVal == "Estrangeiro") this.cnpjValidado = true;
      else this.cnpjValidado = false;
    }
  },
  computed: {
    quantidadeDeItens() {
      return get(this.pagamentos, "totalElements", 0);
    },
    ...mapState({
      pagamentos: state => state.pagamentos,
      loadingDepartments: state => state.loadingDepartments,
      loggedUser: state => state.loggedUser
    }),
    formTitle() {
      return this.editedIndex === -1 ? "Nova Liberação" : "Editar Liberação";
    },
    validarFormulario() {
      if (this.isValid && this.editedItem.fornecedores.length > 0) return true;
      else return false;
    }
  },
  methods: {
    getLodash: get,
    debounceValidation: debounce(async function validaSeValorJaFoiRegistrado() {
      if (this.cnpjDigitado.length == 14) {
        this.loadingCNPJ = true;
        this.carregarDados(`/validacao?cnpj=${this.cnpjDigitado}`)
          .then(s => {
            if (s.data == undefined) {
              this.cnpjValidado = false;
              this.msgErroCnpj = "Nenhum fornecedor foi localizado.";
            } else {
              this.cnpjLocalizado = s.data;
              this.cnpjValidado = true;
            }
          })
          .catch(e => {
            this.cnpjValidado = false;
          })
          .finally(f => {
            this.loadingCNPJ = false;
          });
      }
    }, 500),
    carregarEstrangeiros() {
      if (this.estrangeiros.length <= 0) {
        this.loadingEstrangeiros = true;
        this.carregarDados("/fornecedores/estrangeiro?size=50000")
          .then(s => {
            this.estrangeiros = s.data.content;
          })
          .catch(e => {
            this.estrangeiros = [];
          })
          .finally(s => {
            this.loadingEstrangeiros = false;
          });
      }
    },
    formatarListaCnpj(listaDeCnpj) {
      return listaDeCnpj.map(f => {
        if (f.cnpj == null) return f.nome;
        else return f.nome + " - " + this.formataCnpj(f.cnpj, "Jurídico");
      });
    },
    formataStatus(status) {
      if (status) return "Ativo";
      else return "Inativo";
    },
    formataCnpj(cnpj, tipo) {
      if (tipo == "Jurídico") {
        return cnpj.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      } else return cnpj;
    },
    adicionaCnpj() {
      let editandoItem = this.editedIndexCnpj > -1;
      let copiaEditado = { ...this.cnpjItem };
      copiaEditado.tipo = this.tipoSelecionado;

      let validado = true;
      if (
        this.tipoSelecionado != "Estrangeiro" &&
        this.cnpjDigitado.length < 14
      ) {
        validado = false;
      }
      if (
        this.tipoSelecionado == "Estrangeiro" &&
        copiaEditado.nome == undefined
      ) {
        validado = false;
      }

      if (validado) {
        if (this.tipoSelecionado != "Estrangeiro") {
          copiaEditado.nome = this.cnpjLocalizado.nome;
          copiaEditado.id = this.cnpjLocalizado.id;
          copiaEditado.cnpj = this.cnpjLocalizado.cnpj;
        }

        if (editandoItem) {
          this.editedItem.fornecedores[this.editedIndexCnpj] = copiaEditado;
        } else {
          this.editedItem.fornecedores.push(copiaEditado);
        }
        this.zerarVariaveis();
      }
    },
    zerarVariaveis() {
      if (this.tipoSelecionado != "Jurídico") this.cnpjValidado = true;
      else this.cnpjValidado = false;
      this.cnpjItem = {};
      this.msgErroCnpj = "Digite um fornecedor válido acima.";
      this.cnpjDigitado = "";
      this.editedIndexCnpj = -1;
      this.txtBtn = "Adicionar";
    },
    editarCnpj(item, index) {
      this.editedIndexCnpj = index;
      this.txtBtn = "Atualizar";
      if (item.tipo == "Jurídico") {
        this.cnpjDigitado = item.cnpj;
        this.tipoSelecionado = "Jurídico";
        this.cnpjValidado = true;
        this.cnpjLocalizado = { ...item };
      } else {
        this.cnpjItem = { ...item };
        this.tipoSelecionado = "Estrangeiro";
      }
    },
    deletarCnpj(item, index) {
      this.editedItem.fornecedores.splice(index, 1);
    },
    initialize() {
      this.servico = "/validacao/busca?pedido=&fornecedor=";

      this.$store.commit("set", {
        content: [],
        itemName: "pagamentos"
      });

      this.$store.dispatch("get", {
        loaderName: "loadingDepartments",
        service: this.servico,
        itemName: "pagamentos"
      });
    },
    filtrar() {
      const pedido = this.filtro.pedido;
      const cnpj = this.filtro.cnpj
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      this.servico = `/validacao/busca?pedido=${pedido}&fornecedor=${cnpj}`;
      this.$store.dispatch("get", {
        loaderName: "loadingDepartments",
        service: `${this.servico}`,
        itemName: "pagamentos"
      });
    },
    async carregarDados(url) {
      return axios({
        method: "get",
        url: url,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.loggedUser.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(s => {
          return s;
        })
        .catch(e => {
          return e;
        });
    }
  },
  created() {
    this.initialize();
  }
};
</script>

<style scoped>
.paddingTooltip {
  padding: 15px;
}

.btnConfirmDialog {
  margin: auto;
  text-align: center;
}

.messageConfirmDialog {
  font-size: 20px;
  color: white;
  margin: auto;
  text-align: center;
}

.noDataSlot {
  font-size: 1em;
  padding: 10px;
}

.headerColor >>> thead {
  background: #cfd8dc;
}

.headerColor >>> th {
  color: #455a64 !important;
}

.headerColor >>> th i {
  color: #455a64 !important;
}
.listaCnpj {
  color: #333;
  padding: 5px;
  margin-left: 15%;
  border-bottom: 1px solid #f3f3f3;
}

.local-radio .v-messages.theme--light {
  display: none !important;
}
</style>
